import { z } from 'zod';

// One reports table, `config` discriminated on `type`. The shared source of
// truth for the shape, reused by the admin types and POST /api/reports.

export const reportStepSchema = z.object({
  id: z.string(),
  type: z.enum(['Pageview', 'Event']),
  value: z.string().optional(),
});
export type ReportStep = z.infer<typeof reportStepSchema>;

export const funnelReportConfigSchema = z.object({
  type: z.literal('funnel'),
  steps: z.array(reportStepSchema),
});
export type FunnelReportConfig = z.infer<typeof funnelReportConfigSchema>;

export const journeyAnchorSchema = z.object({
  type: z.enum(['Pageview', 'Event']),
  value: z.string(),
});
export type JourneyAnchor = z.infer<typeof journeyAnchorSchema>;

export const journeyReportConfigSchema = z.object({
  type: z.literal('journey'),
  anchor: journeyAnchorSchema,
  direction: z.enum(['forward', 'backward']).optional(),
  depth: z.number(),
  topK: z.number().optional(),
  minCount: z.number().optional(),
  excludeEvents: z.array(z.string()).optional(),
});
export type JourneyReportConfig = z.infer<typeof journeyReportConfigSchema>;

export const reportConfigSchema = z.discriminatedUnion('type', [
  funnelReportConfigSchema,
  journeyReportConfigSchema,
]);
export type ReportConfig = z.infer<typeof reportConfigSchema>;

export const createReportRequestSchema = z.object({
  projectId: z.string().min(1),
  name: z.string().trim().min(1).max(255),
  description: z.string().trim().max(1000).optional(),
  config: reportConfigSchema,
});
export type CreateReportRequest = z.infer<typeof createReportRequestSchema>;
